import { render } from "./ShipmentProductDetail.vue?vue&type=template&id=abf7c066"
import script from "./ShipmentProductDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentProductDetail.vue?vue&type=script&lang=js"

import "./ShipmentProductDetail.vue?vue&type=style&index=0&id=abf7c066&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__